<template>
  <div id="app">
      <router-view />

  </div>
</template>

<script>
import {srWebSocket} from '@/utils/socket';
export default {
    name: 'App',
    methods: {
        initWebSocket() {
            srWebSocket().then(connection => {
                if (!connection) {
                    console.warn('init srWebSocket failure, connection is null');
                    return;
                }
                connection.on('ReceiveMessage', message => {
                    console.log('get msg' + message);
                    if (message) {
                        switch (message.type) {
                            // case 'schedule':
                            //     this.setSocketQueue(message.data);
                            //     break;
                            // 更新设备状态
                            case 'MdmWebMessage':
                                this.$root.$emit('reciveMessage', message.data);
                                break;
                            case 'checkIn':
                                this.$root.$emit('checkIn', message.data);
                                break;
                            default:
                                console.log('未识别消息', message);
                        }
                    }
                });
            });
        },
    },
    created() {
        this.initWebSocket();
        // setTimeout(this.initWebSocket, 2000);
    }
};
</script>
